<template>
  <label :class="type" :disabled="disabled">
    <input
      v-model="inputValue"
      type="checkbox"
      :class="type + '__input'"
      :name="name"
      :checked="checked"
      :disabled="disabled"
      @change="toggleCheck"
    >
    <span :class="type + '__custom'"></span>
    <span v-if="title" :class="type + '__text'">{{ title }}</span>
  </label>
</template>

<script>
import Vue from 'vue'
import { MIXIN_DEFINE_PROP } from '@/mixins/form/input/mixinDefineProp'

export default {
  name: 'VCheckbox',
  inject: { formData: { from: 'formData', default: null } },
  model: {
    prop: 'value',
    event: 'valueChange'
  },
  mixins: [MIXIN_DEFINE_PROP],
  props: {
    checked: Boolean,
    title: String,
    disabled: Boolean,
    value: [Boolean, null],
    name: String,
    type: {
      type: String,
      required: false,
      default: 'checkbox',
      validator (value) {
        return [
          'checkbox',
          'switch'
        ].includes(value)
      }
    }
  },

  computed: {
    inputValue: {
      get () {
        if (this.name && this.formData) {
          return this.formData[this.name]
        } else {
          return this.value
        }
      },
      set (val) {
        if (this.name && this.formData) {
          Vue.set(this.formData, this.name, val)
        }
        this.$emit('valueChange', val)
      }
    }
  },
  methods: {
    toggleCheck () {
      this.$emit('toggle-check')
    }
  }
}
</script>
